/**
 * «Δημιουργία και εκτέλεση» of the quick study, step by step. The steps are
 * the ordinary pages, each doing what its own buttons do, so a quick study
 * gives exactly the numbers the same project gives run by hand:
 *
 *   locate  Τοποθεσία & Γενικά: the user sets the point on the map, then
 *           «Συνέχεια» (QuickStudyBanner).
 *   design  ΦΒ Σύστημα → Ηλεκτρολογικός σχεδιασμός: auto-design, then the
 *           design is saved through the dialog's own save (electrical check
 *           included). ConfigForm drives it.
 *   run     Προσομοίωση & Αναφορές: Execute (autosave included), and the
 *           results card opens when the study has finished.
 *
 * The step lives in the URL (?quick=...), so a reload or a stop simply ends
 * it: whatever was done so far stays in the project, and the user carries on
 * by hand from the page they are on.
 */
export const QUICK_PARAM = "quick";

export const QUICK_STUDY_PATHS = {
  locate: `/project/asset?tab=general&${QUICK_PARAM}=locate`,
  design: `/project/asset?tab=pv&pv=design&design=electrical&${QUICK_PARAM}=run`,
  run: `/feasibility/simulation?${QUICK_PARAM}=run`,
};

/** The quick-study step a location is at, or null. */
export function quickStep(location) {
  const params = new URLSearchParams(location?.search || "");
  const value = params.get(QUICK_PARAM);
  if (!value) return null;
  const path = String(location?.pathname || "");
  if (path === "/project/asset") {
    const tab = params.get("tab");
    if (value === "locate" && tab === "general") return "locate";
    if (value === "run" && tab === "pv") return "design";
    return null;
  }
  if (path === "/feasibility/simulation" && value === "run") return "run";
  return null;
}

/** The same page without the quick-study step: where the flow stops. */
export function withoutQuick(location) {
  const params = new URLSearchParams(location?.search || "");
  params.delete(QUICK_PARAM);
  const search = params.toString();
  return `${location?.pathname || "/"}${search ? `?${search}` : ""}`;
}
